import { useLanguage } from '../contexts/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { SEOHead } from '../components/SEOHead';
import { Heart, Globe, Sparkles, BookOpen } from 'lucide-react';

export default function PhilosophyPage() {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-white">
      <SEOHead />
      <Navbar />
      <main className="pt-28 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl sm:text-5xl font-bold text-[#1D1D1F] mb-6" data-testid="philosophy-title">
            {language === 'es' ? 'Filosofía' : 'Philosophy'}
          </h1>
          <p className="text-lg text-[#86868B] mb-12 max-w-2xl">
            {language === 'es'
              ? 'Creemos en el aprendizaje inmersivo y el arraigo cultural como pilares fundamentales del dominio del español.'
              : 'We believe in immersive learning and cultural roots as fundamental pillars of Spanish mastery.'}
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {[
              {
                icon: <Heart className="h-6 w-6" />, color: '#E63946',
                title: language === 'es' ? 'Arraigo Cultural' : 'Cultural Roots',
                desc: language === 'es'
                  ? 'Más que un idioma, transmitimos una cultura. Nuestros alumnos descubren las tradiciones, la literatura y las costumbres del mundo hispanohablante.'
                  : 'More than a language, we transmit a culture. Our students discover the traditions, literature, and customs of the Spanish-speaking world.'
              },
              {
                icon: <Globe className="h-6 w-6" />, color: '#007AFF',
                title: language === 'es' ? 'Identidad Bilingüe' : 'Bilingual Identity',
                desc: language === 'es'
                  ? 'Ayudamos a los niños a construir una identidad bilingüe sólida. El español no es solo una asignatura — es parte de quiénes son.'
                  : 'We help children build a solid bilingual identity. Spanish is not just a subject — it\'s part of who they are.'
              },
              {
                icon: <Sparkles className="h-6 w-6" />, color: '#34C759',
                title: language === 'es' ? 'Aprendizaje Natural' : 'Natural Learning',
                desc: language === 'es'
                  ? 'Creamos un entorno donde el español se vive, no solo se estudia. Juegos, canciones, proyectos y conversaciones reales.'
                  : 'We create an environment where Spanish is lived, not just studied. Games, songs, projects, and real conversations.'
              },
              {
                icon: <BookOpen className="h-6 w-6" />, color: '#FF9500',
                title: language === 'es' ? 'Excelencia Académica' : 'Academic Excellence',
                desc: language === 'es'
                  ? 'Nuestros profesores son nativos certificados con experiencia en aulas internacionales. La calidad es nuestra prioridad.'
                  : 'Our teachers are certified native speakers with experience in international classrooms. Quality is our priority.'
              },
            ].map((item, i) => (
              <div key={i} className="p-6 bg-[#F5F5F7] rounded-2xl">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{ backgroundColor: `${item.color}15`, color: item.color }}>{item.icon}</div>
                <h3 className="text-lg font-semibold text-[#1D1D1F] mb-2">{item.title}</h3>
                <p className="text-[#86868B] leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <blockquote className="p-8 bg-[#E63946]/5 border-l-4 border-[#E63946] rounded-r-2xl">
            <p className="text-lg text-[#1D1D1F] italic leading-relaxed">
              {language === 'es'
                ? '"De casa al mundo, tu español crece con confianza."'
                : '"From home to the world, your Spanish grows with confidence."'}
            </p>
            <cite className="block mt-3 text-sm text-[#86868B] not-italic">— Colegio ARCE</cite>
          </blockquote>
        </div>
      </main>
      <Footer />
    </div>
  );
}
